import React from 'react';
import { Header } from 'layout';
import { UserAssetsTable } from 'modules';
import { useGetIraUser } from 'hooks/api/iraUser';
import { useGetProfileAssets } from 'hooks/api/portfolio';
import { USER_TYPE } from 'constants/userTypes';
import { USER_STATUS } from 'constants/status';
import { EntityStatus } from 'components/Label';
import StatusUserButton from 'components/StatusUserButton';
import EmptyPage from 'components/EmptyPage';
import IraUserNavTabs from '../components/IraUserNavTabs';
import IraUserBalance from '../components/IraUserBalance';
import IraUserActiveLimitOrders from '../components/IraUserActiveLimitOrders';

import styles from './IraUserAssets.module.css';

const IraUserAssets: React.FC = () => {
  const { data: iraUser } = useGetIraUser();
  const {
    data: assetsData,
    isLoading: portfolioAssetsLoading,
    isError,
    refetch,
    isRefetching,
  } = useGetProfileAssets();

  return (
    <>
      <Header
        title={
          iraUser
            ? `${iraUser?.firstName} ${iraUser?.middleName ?? ''} ${iraUser?.lastName}`
            : ''
        }
        complexComponent={true}
        label={{
          status: iraUser?.profileStatus ?? '',
          entityStatus: EntityStatus.User,
          isAccountClosed: iraUser?.accountClosed,
        }}
        showArrow={true}
      >
        {iraUser && <StatusUserButton user={iraUser} userType={USER_TYPE.iraUser} />}
      </Header>

      <IraUserNavTabs />

      {iraUser?.profileStatus === USER_STATUS.active ? (
        <>
          <div className={styles.metricsWrapper}>
            <IraUserBalance />
            <IraUserActiveLimitOrders />
          </div>
          <UserAssetsTable
            assetsData={assetsData}
            portfolioAssetsLoading={portfolioAssetsLoading}
            isError={isError}
            refetch={refetch}
            isRefetching={isRefetching}
          />
        </>
      ) : (
        <EmptyPage />
      )}
    </>
  );
};

export default IraUserAssets;
